/**
 * Copyright (c) 2016-2020 Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti
 * All Rights Reserved.
 *
 * The software and data contained herein are confidential and
 * proprietary information of Yega Yazilim ("Confidential Information").
 *
 * Users of this software may not disclose such Confidential Information
 * and shall use it only in accordance with the terms of the license agreement
 * they entered into with Yega Yazilim.
 *
 *
 * Author    Ahmet Dogramaci
 * Date      2020-03-16
 */

import DecisionCondition from "../enums/decision-condition";
import ConfigurationTemplateDecisionWatch from "./configuration-template-decision-watch.js"
import ConfigurationTemplateDecisionAction from "./configuration-template-decision-action.js"
import ConfigurationTemplateDecisionTrigger from "./configuration-template-decision-trigger.js"

class ConfigurationTemplateDecision {
    constructor() {
        this.watches = [];
        this.actions = [];
        this.triggers = [];
        this.decision_condition = DecisionCondition.AND;
        this.watches_status_value = null;
        this.template_version_object = null;
        this.used_watches               = [];
        this.used_watch_timeout         = null;
    }

    buildFromJson(json_object){
        this.id = json_object.id;
        this.name = json_object.name;
        this.decision_condition = json_object.decision_condition;
        this.buildWatches(json_object.cfg_template_dec_watches);
        this.buildActions(json_object.cfg_template_dec_actions);
        this.buildTriggers(json_object.cfg_template_dec_triggers);
    }

    buildWatches(watches_json){
        watches_json.forEach((json_object)=>{
            let watch = new ConfigurationTemplateDecisionWatch();
            watch.decision = this;
            watch.buildFromJson(json_object);
            this.addWatch(watch);
        });
    }

    buildActions(actions_json){
        actions_json.forEach((json_object)=>{
            let action = new ConfigurationTemplateDecisionAction();
            action.decision = this;
            action.buildFromJson(json_object);
            this.addAction(action);
        });
    }

    buildTriggers(watches_json){
        watches_json.forEach((json_object)=>{
            let trigger = new ConfigurationTemplateDecisionTrigger();
            trigger.decision = this;
            trigger.buildFromJson(json_object);
            this.addTrigger(trigger);
        });
    }

    addWatch(watch){
        this.watches.push(watch);
    }

    addAction(action){
        this.actions.push(action);
    }

    addTrigger(trigger){
        this.triggers.push(trigger);
    }

    get template_version(){
        return this.template_version_object;
    }

    set template_version(value){
        this.template_version_object = value;
    }

    get isAndDecision(){
        return this.decision_condition === DecisionCondition.AND;
    }

    get isOrDecision(){
        return this.decision_condition === DecisionCondition.OR;
    }

    get hasTrigger(){
        return this.triggers.length > 0;
    }

    get watchesOrStatus(){
        let result = false;
        for(let i=0; i < this.watches.length; i++) {
            let watch = this.watches[i];
            if (watch.isSatisfied) {
                result = true;
                break;
            }
        }
        console.log(`watchesAndStatus for decision :${this.name} is ${result}`);
        return result
    }

    get watchesAndStatus(){
        let result = true;
        for(let i=0; i < this.watches.length; i++) {
            let watch = this.watches[i];
            if (!watch.isSatisfied) {
                result = false;
                break;
            }
        }
        console.log(`watchesAndStatus for decision :${this.name} is ${result}`);
        return result;
    }

    get watchesStatus(){
        if(this.isAndDecision){
            return this.watchesAndStatus
        }else{
            return this.watchesOrStatus
        }
    }

    evaluateWatchStatus(){
        if(this.watchesStatus && !this.watches_status_value){
            console.log(`evaluateStatus for decision :${this.name} is true`);
            this.watches_status_value = true;
            if(!this.hasTrigger){
                this.performActions(true);
            }
        }
        if(!this.watchesStatus && this.watches_status_value){
            console.log(`evaluateStatus for decision :${this.name} is false`);
            this.watches_status_value = false;
            if(!this.hasTrigger){
                this.performActions(false);
            }
        }

    }

    performActions(isConditionSatisfied){
        for(let i=0; i < this.actions.length; i++ ){
            let action = this.actions[i];
            action.executeAction(isConditionSatisfied);
        }
    }
}
export default ConfigurationTemplateDecision;